// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1OHZB","footer":"ModalCreateQualiphyProcedure_footer__1zlq8","additionData":"ModalCreateQualiphyProcedure_additionData__1TlaS"};